'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupCode$() {
  this.c6h = null;
  this.c6i = false;
  this.c6f = null;
  this.c6g = false;
}
export { $c_Lpresto_types$GroupCode$ as $c_Lpresto_types$GroupCode$ };
$p = $c_Lpresto_types$GroupCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupCode$;
/** @constructor */
function $h_Lpresto_types$GroupCode$() {
}
export { $h_Lpresto_types$GroupCode$ as $h_Lpresto_types$GroupCode$ };
$h_Lpresto_types$GroupCode$.prototype = $p;
$p.jX = (function() {
  if ((!this.c6i)) {
    this.c6h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6i = true;
  }
  return this.c6h;
});
$p.iK = (function() {
  if ((!this.c6g)) {
    this.c6f = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c6g = true;
  }
  return this.c6f;
});
var $d_Lpresto_types$GroupCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupCode$, "presto.types$GroupCode$", ({
  a0v: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupCode$ as $d_Lpresto_types$GroupCode$ };
var $n_Lpresto_types$GroupCode$;
function $m_Lpresto_types$GroupCode$() {
  if ((!$n_Lpresto_types$GroupCode$)) {
    $n_Lpresto_types$GroupCode$ = new $c_Lpresto_types$GroupCode$();
  }
  return $n_Lpresto_types$GroupCode$;
}
export { $m_Lpresto_types$GroupCode$ as $m_Lpresto_types$GroupCode$ };
//# sourceMappingURL=presto.types$-Group-Code$.js.map
